import * as React from "react";
import Modal from "../ui/modal/Modal";
import ButtonPrimary from "../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";

interface ComponentProps {
	/**
	 * On close action.
	 */
	onClose: () => void;
	/**
	 * On confirm action.
	 */
	onConfirm: () => void;
	/**
	 * Indicates if appointment type is survey and appointment contact has email address.
	 */
	surveyWithEmail?: boolean;
	/**
	 * Indicates if appointment type is survey and appointment contact has mobile phone number.
	 */
	surveyWithMobile?: boolean;
}

type Props = ComponentProps;

export default class ConfirmAppointmentStatusChangeModal extends React.PureComponent<Props, {}> {
	render() {
		let text: string;
		if (this.props.surveyWithEmail && this.props.surveyWithMobile) {
			text =
				`Changing status of appointment to "Confirmed" will automatically send an SMS and confirmation email to the Prospect. Would you like to proceed?`
		}
		else if (this.props.surveyWithEmail) {
			text =
				`Changing status of appointment to "Confirmed" will automatically send a confirmation email to the Prospect. Would you like to proceed?`
		}
		else {
			text =
				`Changing status of appointment to "Confirmed" will automatically send an SMS to the Prospect. Would you like to proceed?`
		}

		return (
			<Modal onCloseClicked={this.props.onClose} title={"Confirm"} autoWidth={true}>
				<div style={{width: "600px"}}>
					<p>{text}</p>
					<ButtonTertiary label={"Cancel"} onClick={this.props.onClose}/>
					<div className={"pull-right"}>
						<ButtonPrimary label={"Process"} onClick={() => {this.props.onConfirm()}}/>
					</div>
				</div>
			</Modal>
		)
	}
}